import CarnivoreCtx from 'editor/components/CarnivoreCtx';
import CarnivoreDoc from 'editor/components/CarnivoreDoc';
import DOMOverlay from 'editor/components/DOMOverlay';
import EditorMode from 'editor/components/EditorMode';
import Tool, { EditorTools } from 'editor/components/Tool';
import { createContext } from 'react';

export type ECSEditorContextContent = {
  carnCtx: CarnivoreCtx;
  doc: CarnivoreDoc;
  domOverlay: DOMOverlay;
  tool: Tool<EditorTools>;
  mode: EditorMode;
};

const ECSEditorContext = createContext<ECSEditorContextContent>({
  carnCtx: null as unknown as CarnivoreCtx,
  doc: null as unknown as CarnivoreDoc,
  domOverlay: new DOMOverlay('dom-overlay', 1),
  tool: new Tool(EditorTools.Pointer),
  mode: new EditorMode(),
});

export default ECSEditorContext;
